import { isTag } from 'anodum';
import { LIST_ELEMENTS } from '../constants/editable-elements';

const isPreviousElementNumberedList = (node) => {
  const prevSibling = node.previousElementSibling;
  return prevSibling && isTag(prevSibling, LIST_ELEMENTS[1]);
};

export default isPreviousElementNumberedList;
